module.exports = __webpack_public_path__ + "img/tx_700.438b6ef4.jpg";